import { render } from "./MfgPaintingProductionStatistics3.vue?vue&type=template&id=95c28536&scoped=true"
import script from "./MfgPaintingProductionStatistics3.vue?vue&type=script&lang=js"
export * from "./MfgPaintingProductionStatistics3.vue?vue&type=script&lang=js"

import "./MfgPaintingProductionStatistics3.vue?vue&type=style&index=0&id=95c28536&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c28536"]])

export default __exports__